function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import moment from 'moment';
import { motion, AnimatePresence } from 'framer-motion';
import Link from 'components/Link';
import Button from 'components/Form/Button';
import Sync from 'svg/sync.svg';
import CheckNegative from 'svg/check-negative.svg';
import XNegativeIcon from 'svg/x-negative.svg';
import Dots from 'svg/dots.svg';
import App from 'modules/App';
import Patient from 'modules/Patient';
import Account from 'modules/Account';
import Information from 'modules/Information';
import Visit from 'modules/Visit';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from '../Results/Results.pcss';
var _React_PureComponent;
class MyHeader extends (_React_PureComponent = React.PureComponent) {
    async onOpenMenu(evt) {
        evt.preventDefault();
        const isOpenMenu = this.props.openDropdownId === constants.PROFILE_DROPDOWN;
        await this.props.onCloseDropdown();
        if (!isOpenMenu) {
            this.props.onOpenDropdown(constants.PROFILE_DROPDOWN);
        }
    }
    /**
   * Sync statuses:
   * 0 - unsynchronized
   * 1 - synchronizing in progress
   * 2 - sync success
   * 3 - sync error
   */ get syncStatus() {
        if (this.props.isSyncInProgress) return 1;
        if (this.props.hasSyncErrors) return 3;
        return 2;
    }
    get ageValue() {
        const dateOfBirth = get(this.props.information, 'dateOfBirth');
        if (!dateOfBirth) return null;
        const patientYears = moment().diff(dateOfBirth, 'years');
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                `${patientYears} `,
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.yearsOld))
            ]
        });
    }
    get diabetesTypeValue() {
        const { phiSet } = this.props;
        const diabetesType = get(phiSet, 'diabetesType') || 'NoResponse';
        if (!App.messages.diabetesTypes[diabetesType]) return null;
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.diabetesTypes[diabetesType]));
    }
    get treatmentTypeValue() {
        const { phiSet } = this.props;
        const treatmentType = get(phiSet, 'treatmentType') || 'NoResponse';
        if (!App.messages.treatmentTypes[treatmentType]) return null;
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.treatmentTypes[treatmentType]));
    }
    renderMenu() {
        if (this.props.openDropdownId !== constants.PROFILE_DROPDOWN) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                height: 0
            },
            animate: {
                height: 'auto'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "dropdownMenu__actions",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "transparent",
                            type: "button",
                            onClick: ()=>this.props.onOpenModal(constants.MEASUREMENTS_MODAL),
                            labelMessage: messages.buttons.editPatient
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "transparent",
                            type: "button",
                            onClick: ()=>this.props.onOpenModal(Visit.constants.VISIT_HISTORY_MODAL),
                            labelMessage: messages.buttons.visitHistory
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "transparent",
                            type: "button",
                            onClick: ()=>this.props.onSync(),
                            labelMessage: messages.buttons.refresh
                        })
                    })
                ]
            })
        });
    }
    renderSync() {
        switch(this.syncStatus){
            case 1:
                {
                    return /*#__PURE__*/ _jsxs("span", {
                        className: styles.sync,
                        children: [
                            /*#__PURE__*/ _jsx(Sync, {
                                className: `${styles.sync__icon} rotating`
                            }),
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.synchronizing))
                        ]
                    });
                }
            case 2:
                {
                    return /*#__PURE__*/ _jsxs("span", {
                        className: cn(styles.sync, styles['sync--synchronized']),
                        children: [
                            /*#__PURE__*/ _jsx(CheckNegative, {
                                className: `${styles.sync__icon} ${styles['sync__icon--check']}`
                            }),
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.synchronized))
                        ]
                    });
                }
            case 3:
                {
                    return /*#__PURE__*/ _jsxs("span", {
                        className: cn(styles.sync, styles['sync--unsynchronized']),
                        children: [
                            /*#__PURE__*/ _jsx(XNegativeIcon, {
                                className: `${styles.sync__icon} ${styles['sync__icon--check']}`
                            }),
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unsynchronized))
                        ]
                    });
                }
            default:
                {
                    return null;
                }
        }
    }
    renderPatientInformation(label, value, withoutMargin) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("p", {
                    className: styles.patientAdditionalInfoLabel,
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, label)),
                        ":"
                    ]
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: cn(styles.patientAdditionalInfoValue, {
                        [styles['patientAdditionalInfoValue--noMargin']]: withoutMargin
                    }),
                    children: value || '-'
                })
            ]
        });
    }
    renderAdditionalPatientInformation() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.patientName__wrapper, styles.additionalPatientInfo),
            children: [
                this.renderPatientInformation(messages.labels.age, this.ageValue),
                this.renderPatientInformation(messages.labels.diabetesType, this.diabetesTypeValue),
                this.renderPatientInformation(messages.labels.treatmentType, this.treatmentTypeValue, true)
            ]
        });
    }
    renderPatientHeader() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col",
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn('row align-items-center', styles.patientWrapper),
                children: [
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        children: this.renderMenu()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.profileSettings, 'col-auto'),
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>this.onOpenMenu(evt),
                            children: /*#__PURE__*/ _jsx(Dots, {})
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: cn(styles.patientName__wrapper),
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            className: cn(styles.patient__name),
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.myResults))
                                        }),
                                        this.renderSync()
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "row",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "d-flex justify-content-center align-items-center",
                                    children: this.renderAdditionalPatientInformation()
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "row align-items-center",
            children: this.renderPatientHeader()
        });
    }
}
_define_property(MyHeader, "propTypes", {
    // Explicit actions
    onSync: PropTypes.func,
    // Implicit props
    information: PropTypes.object,
    patientProfile: PropTypes.object,
    phiSet: PropTypes.object,
    phiSetDocumentId: PropTypes.string,
    isSyncInProgress: PropTypes.bool,
    hasSyncErrors: PropTypes.bool,
    openDropdownId: PropTypes.string,
    // Implicit actions
    onCloseDropdown: PropTypes.func,
    onOpenDropdown: PropTypes.func,
    onOpenModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        patientProfile: Account.selectors.patientProfile(state),
        information: Information.selectors.information(state),
        phiSet: Patient.selectors.phiSet(state),
        phiSetDocumentId: Patient.selectors.phiSetDocumentId(state),
        isSyncInProgress: Patient.selectors.isSyncInProgress(state),
        hasSyncErrors: Patient.selectors.hasSyncErrors(state),
        openDropdownId: App.selectors.dropdown(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedMyHeader = connect(mapStateToProps, mapDispatchToProps)(MyHeader);
export default ConnectedMyHeader;
